<template>
  <router-link :to="to" :active-class="activeClass" :target="target">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  props: {
    to: {
      type: [String, Object]
    },
    tag: {
      type: String
    },
    'active-class': {
      type: String,
      default: 'router-link-active'
    },
    target: {
      type: String
    }
  }
}
</script>
